import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  timeLineScroll: {
    overflowX: 'auto',
    overflowY: 'hidden',
    '-ms-overflow-style': '-ms-autohiding-scrollbar',
    '-webkit-overflow-scrolling': 'touch',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&.bp320, &.bp375, &.bp414': {
      '& .label': {
        paddingRight: '76px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(18),
        marginBottom: theme.typography.pxToRem(6),
      },
      '& .label-0': {
        paddingRight: '0',
      },
    },
    '&.bp320': {
      maxWidth: '320px',
    },
    '&.bp375': {
      maxWidth: '375px',
    },
    '&.bp414': {
      maxWidth: '414px',
    },
    [theme.breakpoints.only('sm')]: {
      maxWidth: '960px',
    },
    '&.onDesktop': {
      display: 'none',
      [theme.breakpoints.up('xs')]: {
        display: 'block',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    '&.onMobil': {
      display: 'none',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
      },
    },
  },
  timeLineContainer: {
    display: 'flex',
    marginBottom: '51px',
    padding: '32px 0 10px 1px',

    [theme.breakpoints.down('xs')]: {
      width: '540px',
      marginBottom: 0,
      paddingLeft: '20px',
    },

    '&.bp768': {
      marginBottom: '28px',

      '& .bp:last-child': {
        flex: '3 0',
      },

      [theme.breakpoints.down('xs')]: {
        marginBottom: '0px',
      },
    },
  },
  timeLine: {
    borderTop: `solid 1px ${theme.palette.grey6}`,
    paddingTop: '21px',
    fontFamily: theme.typography.proxima.regular,
    position: 'relative',
    flex: '6 0',

    '&:last-child': {
      flex: '3 0',
      [theme.breakpoints.down('xs')]: {
        flex: '4 0',
      },
    },

    '&::after': {
      backgroundColor: theme.palette.grey6,
      content: '""',
      display: 'block',
      height: '8px',
      left: '0',
      top: '-4px',
      position: 'absolute',
      width: '8px',
      zIndex: '1',
      borderRadius: '50%',
    },

    '& .checkBg': {
      backgroundColor: theme.palette.grey5,
      content: '""',
      display: 'block',
      height: '14px',
      left: '0',
      top: '-4px',
      position: 'absolute',
      width: '14px',
      zIndex: '2',
      borderRadius: '50%',
    },

    '&.completed': {
      '& .label': {
        fontFamily: 'ProximaBold',
        color: theme.palette.blue1,
      },
    },

    '& .label': {
      fontSize: theme.typography.pxToRem(16),
    },

    '&.bp': {
      '& .label': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(18),
        marginBottom: theme.typography.pxToRem(6),
        width: '88px',

        '&-1, &-2, &-3': {
          width: '53px',
        },
      },
    },

    '&.bp1024': {
      '& .label': {
        paddingRight: '104px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(18),
        marginBottom: theme.typography.pxToRem(6),
      },
      '& .label-0': {
        paddingRight: '44px',
        [theme.breakpoints.down('xs')]: {
          paddingRight: '34px',
        },
      },
      '& .label-1': {
        paddingRight: '118px',
      },
      '& .label-3': {
        paddingRight: '40px',
      },
      [theme.breakpoints.down('xs')]: {
        flex: '4 0',
      },
    },

    '&.bp1024.bp959': {
      '& .label-0': {
        paddingRight: '46%',
      },
      '& .label-1': {
        paddingRight: '76%',
      },
      '& .label-2': {
        paddingRight: '70%',
      },
      '& .label-3': {
        paddingRight: '58%',
      },
    },

    '&.bp1024:last-child': {
      flex: '3 0',
    },

    '& .date': {
      fontSize: theme.typography.pxToRem(12),
      letterSpacing: theme.typography.pxToRem(2),
      textTransform: 'uppercase',

      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(10),
      },
    },

    '& svg': {
      color: theme.palette.blue1,
      left: '-3px',
      top: '-12px',
      position: 'absolute',
      zIndex: '3',
    },
  },
}));

export default useStyles;
